import Helper from "./Helper";
import { CountUp } from "countup.js";

class CountUpNumbers {
  constructor(config = {}) {
    const {
      numbersSelector,
      classIn,
      classOut,
      langArray,
      decimalArray,
      thousandSepArray,
    } = config;

    this.numbersSelector = numbersSelector;
    this.classIn = classIn;
    this.classOut = classOut;

    this.decimal = "";
    this.separator = "";

    langArray.forEach((lang, index) => {
      if (document.documentElement.lang == lang) {
        this.decimal = decimalArray[index];
        this.separator = thousandSepArray[index];
      }
    });

    this.init();
  }

  init() {
    const allNumbers = document.querySelectorAll(this.numbersSelector);

    if (!allNumbers || allNumbers.length === 0) return;

    this.numbersArray = Array.from(allNumbers).filter(
      (el) => !el.closest(".swiper-slide-duplicate")
    );

    if (this.numbersArray.length === 0) return;

    this.numberData = [];
    this.numbersArray.forEach((item) => {
      const numText = item.innerText.replace(/\s+/g, "").trim();
      const data = this.parseNumber(numText);
      this.numberData.push(data);
    });

    this.numbersArray.forEach((item, index) => {
      item.dataset.target = this.numberData[index].value;
      item.dataset.countupIndex = index;
      item.id = "countup-" + index + "-" + Date.now();
    });

    this.observeElements();
  }

  observeElements() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const item = entry.target;
          const index = parseInt(item.dataset.countupIndex, 10);

          if (entry.isIntersecting && !item.classList.contains("counting")) {
            item.classList.add("counting");
            Helper.addClass(item, this.classIn);
            Helper.removeClass(item, this.classOut);

            const data = this.numberData[index];

            const opts = {
              startVal: 0,
              duration: 4,
              useEasing: true,
              separator: data.thousandSep,
              decimal: data.decimalSep,
              decimalPlaces: data.decimalPlaces,
            };

            const countUp = new CountUp(item, data.value, opts);

            if (!countUp.error) {
              countUp.start();
            } else {
              console.error("CountUp error:", countUp.error);
            }

            // Stop observing once animated
            observer.unobserve(item);
          }
        });
      },
      {
        threshold: 0.5, // trigger when 50% of the element is visible
      }
    );

    this.numbersArray.forEach((item) => {
      observer.observe(item);
    });
  }

  parseNumber(text) {
    let clean = text;

    const hasComma = clean.includes(",");
    const hasDot = clean.includes(".");

    let thousandSep = "";
    let decimalSep = ".";
    let decimalPlaces = 0;

    if (hasComma && hasDot) {
      const lastComma = clean.lastIndexOf(",");
      const lastDot = clean.lastIndexOf(".");

      if (lastComma > lastDot) {
        thousandSep = ".";
        decimalSep = ",";
        decimalPlaces = clean.length - lastComma - 1;
        clean = clean.replace(/\./g, "").replace(",", ".");
      } else {
        thousandSep = ",";
        decimalSep = ".";
        decimalPlaces = clean.length - lastDot - 1;
        clean = clean.replace(/,/g, "");
      }
    } else if (hasComma && !hasDot) {
      const commaPos = clean.indexOf(",");
      const afterComma = clean.substring(commaPos + 1);

      if (/^\d{3}$/.test(afterComma)) {
        thousandSep = ",";
        decimalSep = ".";
        decimalPlaces = 0;
        clean = clean.replace(/,/g, "");
      } else {
        thousandSep = "";
        decimalSep = ",";
        decimalPlaces = afterComma.length;
        clean = clean.replace(",", ".");
      }
    } else if (hasDot && !hasComma) {
      const dotPos = clean.indexOf(".");
      const afterDot = clean.substring(dotPos + 1);

      if (/^\d{3}$/.test(afterDot) && clean.length > 4) {
        thousandSep = ".";
        decimalSep = ",";
        decimalPlaces = 0;
        clean = clean.replace(/\./g, "");
      } else {
        thousandSep = "";
        decimalSep = ".";
        decimalPlaces = afterDot.length;
      }
    }

    const value = parseFloat(clean);

    return {
      value: isNaN(value) ? 0 : value,
      thousandSep,
      decimalSep,
      decimalPlaces,
    };
  }
}

export default CountUpNumbers;
